import { useCallback, useState } from 'react'
import { API } from '../../services/api'
import { isValidEmail } from '../../utils/email'

export type DeleteAccountRequestError = 'invalidEmail' | 'tooManyRequests' | 'unexpected'

const errorForStatus = (status?: number): DeleteAccountRequestError => {
  if (status === 400) return 'invalidEmail'
  if (status === 429) return 'tooManyRequests'
  return 'unexpected'
}

export const useDeleteAccountRequest = () => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState<DeleteAccountRequestError | null>(null)

  const changeEmail = useCallback((value: string) => {
    setEmail(value)
    setError(null)
  }, [])

  const submit = useCallback(async () => {
    const address = email.trim()
    if (!isValidEmail(address)) {
      setError('invalidEmail')
      return
    }
    setLoading(true)
    setError(null)
    const response = await API.getInstance().requestAccountDeletion(address)
    setLoading(false)
    if (response.ok) setSent(true)
    else setError(errorForStatus(response.status))
  }, [email])

  return { email, changeEmail, loading, sent, error, submit }
}
